module.exports = __webpack_public_path__ + "static/console-metrics-a89e4125b4a05f853fb9bc9bc617474f.jpg";